import React from 'react';
import { useTranslation } from 'react-i18next';

import { HOUSE_NUMBER_FIELD_REGEX } from '@thinknet-gmbh/platform-common';

import {
  Form,
  ButtonsWrapper,
  Button,
  TextInput,
  NumberInput,
} from '@thinknet-gmbh/platform-common-ui';

import { useGetLocationsAssignedDatevNumbers } from 'src/hooks/companies/get-locations-datevnumbers.hook';

import HealthInsuranceNumbersFormList from './components/health-insurance-numbers-form-list/health-insurance-numbers-form-list.component';

import { IHealthInsuranceTableValues } from '../../health-insurance-interfaces';

const HealthInsuranceForm = ({
  onClose,
  onFinishHandler,
  initialValues,
  loading,
  isEdit,
}: {
  loading?: boolean;
  isEdit?: boolean;
  onClose: () => void;
  onFinishHandler: (values: any) => void;
  initialValues: IHealthInsuranceTableValues;
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const { datevNumbers } = useGetLocationsAssignedDatevNumbers();

  return (
    <Form
      layout="vertical"
      onFinish={values => onFinishHandler(values)}
      initialValues={initialValues}
      form={form}
    >
      <Form.Item
        name="name"
        label={t('settings:healthInsurance.labels.name')}
        rules={[{ required: true, message: t('customers:error.fieldIsRequired') }]}
      >
        <TextInput placeholder={'AOK'} disabled={isEdit} />
      </Form.Item>
      <Form.Item name={'street'} label={t('common:labels.address.street')}>
        <TextInput placeholder="St. Petersburger str. 1a" maxLength={34} />
      </Form.Item>

      <Form.Item
        name={'houseNumber'}
        label={t('employee:employeePersonalInfo.labels.houseNumber')}
        rules={[
          { required: false, message: t('customers:error.fieldIsRequired') },
          {
            pattern: HOUSE_NUMBER_FIELD_REGEX,
            message: t('common:validation.error.houseNumberFormat'),
          },
        ]}
      >
        <TextInput placeholder="27" maxLength={9} />
      </Form.Item>

      <Form.Item
        name={'zipCode'}
        label={t('common:labels.address.zipCode')}
        rules={[
          { required: false, message: t('customers:error.fieldIsRequired') },
          {
            pattern: new RegExp(/^-?\d+$/),
            message: t('common:validation.error.mustBeInteger'),
          },
        ]}
      >
        <NumberInput
          thousandSeparator={false}
          allowLeadingZeros={false}
          allowNegative={false}
          placeholder="27321"
          maxLength={5}
        />
      </Form.Item>

      <Form.Item name={'city'} label={t('common:labels.address.city')}>
        <TextInput placeholder="Hamburg" maxLength={34} />
      </Form.Item>

      <HealthInsuranceNumbersFormList form={form} datevNumbers={datevNumbers} />

      <ButtonsWrapper marginTop={16}>
        <Button type="primary" loading={loading} htmlType="submit">
          {t('common:buttons.save')}
        </Button>
        <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default HealthInsuranceForm;
